<div class="bg-color" *ngIf="clientPlatformService.isBackButtonVisible">
  <div>
    <button mat-button fxLayoutAlign="start start" color="primary" (click)="connectionService.redirectToParent()">
      <mat-icon>arrow_back</mat-icon>
      <span class="back-button">Back</span>
    </button>
  </div>
</div>
<app-workspace *ngIf="uic.manageWorkspaceComponent('get')" (dataRefresh)="initialize()" [parentPage]="'connection'"></app-workspace>
<div class="error" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.7%" *ngIf="isZeroConnection">
  <span style="font-size: x-large">ℹ️ </span>
  <span>Please Create New Connection !!</span>
</div>
<app-box-picker *ngIf="connectionService.workSpaceId || !this.isBrowser" (selectedBox)="addNewRecord($event)" [config]="appConfig" header="Select an App for New Connection"></app-box-picker>